import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiToyGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-toy-generator',
			name: 'AI Toy Generator — Photos Into AI Toy Figures | Lift',
			description:
				'Transform your photos into AI toy figures instantly with Lift. Upload a photo, apply a filter, and the AI generates mini-you figures. No watermark. ',
			url: 'https://liftapp.ai/ai-toy-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-toy-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-toy-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-toy-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-toy-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-toy-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-toy-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-toy-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-toy-generator#product',
			name: 'AI Toy Generator Online',
			description:
				'Instantly transform your photos into playful, mini-you figures — no design skills needed. Perfect for sharing on Instagram, TikTok, or anywhere you want to show off your unique style and personality. Create, collect, and wow your friends with your one-of-a-kind digital toy avatar!',
			url: 'https://liftapp.ai/ai-toy-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-toy-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI creates your toy figure',
					text: 'Instantly convert your photo into a cinematic, animated-style artwork',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-toy-generator#benefits',
			name: 'Who can benefit from AI Toy Generator?',
			description:
				"Lift's AI Toy Generator is useful for beginners, casual creators, social media users, influencers, friends, and families.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Designed for beginners and casual creators looking to improve their visuals fast',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Ideal for social media posts, quick edits, or building a personal brand',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Influencers can maintain a consistent aesthetic with minimal effort',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Friends and families can turn everyday selfies into hilarious, shareable moments',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Quick, creative, and premium-quality — ideal for personal fun',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Toy Generator Benefits',
				description: 'Users enjoying AI Toy Generator features',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-toy-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Toy Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Toy Generator is an online tool that transforms your photos into realistic toy figures — complete with packaging, sculpted details, and collectible aesthetics. Perfect for social media, gifts, or just seeing yourself as an action figure.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Toy Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo and reimagines it as a toy figure, adding packaging design, toy-specific textures, sculpted proportions, and collectible styling. Everything is automatic — no 3D modeling or design skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create Toy figure from any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works best with clear portraits but can transform any photo into Toy figure. The AI adapts to your image while preserving your unique features and personality.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, prints, or sharing with friends.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-toy-generator#why-lift',
			name: "Why Lift's AI Toy Generator stands out",
			description:
				"Lift's AI Toy Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'AI Toy Generator',
				description: 'AI Toy Generator advantages and features',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-toy-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-toy-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Toy Generator',
					item: 'https://liftapp.ai/ai-toy-generator',
				},
			],
		},
	],
};
